import template from './commissionStatsRow.html';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    commissionSummary: '<',
  },
};
